var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-gray-light"},[_c('div',{staticClass:"px-2 my-4 sm:px-6"},[_c('Breadcrumbs',{staticClass:"mb-8",attrs:{"crumbs":_vm.crumbs}}),_c('Ticket',{attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }